module.exports = __webpack_public_path__ + "img/shoping_bag.fe834da6.svg";